export const excelStyles = [
    { font: { color: "#000000", fontName: "Arial", size: 10 }, id: "cell" },
    { font: { color: "#FFFFFF", fontName: "Arial", size: 10 }, id: "header", interior: { color: "#2F75B5", pattern: "Solid" } }
];
